import Menu from "./menu-item";

require('./bootstrap');

import Inputmask from "inputmask";
import $ from "jquery";

import './slider.js';
import './sticky-header';
import './menu';
import './gmap';
import './shopping-cart-details';
import './validator';
import './animation';
import './call-to-action';
import './tabs';
import './comboProduct';
import './phoneValidate';

$(document).ready(() => {
    $(document).on('blur', '.form-el .form-input', function () {
        $(this).parent().removeClass('is-active');
    });

    $(document).on('focus', '.form-el .form-input', function () {
        $(this).parent().addClass('is-active');
    });

    $('.nav-switcher a').on('click', function (e) {
        e.preventDefault();
        if ($(this).parent().index() !== 0) {
            $('.nav-switcher').addClass('slide');
        } else {
            $('.nav-switcher').removeClass('slide');
        }
    });

    const modalDeliveryNotice = $('#modalDeliveryNotice');

    $('.js-dropdown-radio-btn').on('click', function (e) {

        if (!$(this).closest('.js-switcher').hasClass('with-notice')) {

            // if ($(this).closest('.js-switcher').hasClass('js-without-notice')) {
            location.href = $(this).data('link')
            // }

            return true;
        }

        e.preventDefault();
        e.stopPropagation();

        const to = $(this).data('to');
        const link = $(this).data('link');
        const info = $(this).closest('.js-switcher').data('info');
        const changeType = $('.js-change-type');

        if (['pickup', 'delivery'].includes(to) && ($(this).hasClass('active') || $(this).closest('.js-switcher').hasClass('disabled'))) {

            return;
        }

        $(this).parent().siblings('.nav-item').find('a').removeClass('active show');

        $('.js-modal-notice').html(info);

        modalDeliveryNotice.modal('show');

        changeType.on('click', function () {
            location.href = link
        });
    });


    $.fn.socialPopup = function (e, intWidth, intHeight, blnResize) {
        e.preventDefault();

        var intWidth = intWidth || '500';
        var intHeight = intHeight || '400';
        var strResize = (blnResize ? 'yes' : 'no');
        var strTitle = ((typeof this.attr('title') !== 'undefined') ? this.attr('title') : 'Social Share'),
            strParam = 'width=' + intWidth + ',height=' + intHeight + ',resizable=' + strResize,
            objWindow = window.open(this.attr('href'), strTitle, strParam).focus();
    };

    $('.share').on('click', function (e) {
        $(this).socialPopup(e);
    });

    updateAppLinks();

    if ($('.init-scroll-to-it').length) {
        var target = $('.init-scroll-to-it');
        if (target.length) {
            var top = target.offset().top;
            $('html,body').animate({scrollTop: top - 80}, 300);
            return false;
        }
    }

    const modalNotice = $('#modalNotification');
    if (modalNotice) {
        modalNotice.modal('show');
    }

    const headerCat = document.getElementById("categoriesMenu");

    if (headerCat) {
        window.onscroll = function () {
            categoriesMenuStickyFunction()
        };
        const sticky = headerCat.offsetTop - 80;

        function categoriesMenuStickyFunction() {
            if (window.pageYOffset > sticky) {
                headerCat.classList.add("sticky");
            } else {
                headerCat.classList.remove("sticky");
            }
        }

        $('.cat-mark-js,.cat-mark-ft-js').on('click', function (e) {
            const width = document.body.clientWidth;
            const url = $(this).data('url');
            let val = '-40';
            let el = document.getElementById(url);

            if (el) {
                e.preventDefault();
                e.stopPropagation();
            }

            if (width < 992) {
                val = '-80';
            } else {
                if (window.pageYOffset < sticky) {
                    val = '-120';
                }
            }

            let pos = el.style.position;
            let top = el.style.top;
            el.style.position = 'relative';
            el.style.top = val + 'px';
            // el.scrollIntoView({behavior: 'smooth', block: 'start'});
            el.scrollIntoView({block: 'start'});
            el.style.top = top;
            el.style.position = pos;

            $('.cat-mark-js').parent().css('border-bottom', '2px solid transparent');
            $('.nav-item').find("[data-url='" + url + "']").parent().css('border-bottom', '2px solid #FE5000');
        });

        const elements = document.querySelectorAll('.js-scroll');
        elements.forEach((el) => {
            document.addEventListener('scroll', function () {
                const rect = el.getBoundingClientRect();
                const isInViewport = rect.top >= 0 && rect.bottom <= 600//<= (window.innerHeight || document.documentElement.clientHeight);

                if (isInViewport) {
                    let id = el.closest('.categories').getAttribute('id');
                    $('.cat-mark-js').parent().css('border-bottom', '2px solid transparent');
                    $('.nav-item').find("[data-url=" + id + "]").parent().css('border-bottom', '2px solid #FE5000');
                }
            }, {
                passive: true
            });
        });

    }

    $('.md-dropdown-js').on('click', function () {
        const overlay = '.md-dropdown-overlay';
        const self = this;

        $(overlay).removeClass("active");

        $('.md-dropdown-js ul').css({transform: 'translateY(100%)', display: 'none'});
        $(this).parent().find(overlay).addClass("active");
        $(this).parent().find('ul').css({display: 'block'});

        setTimeout(function () {
            $(self).parent().find('ul').css({transform: 'translateY(0)'});
        }, 50);

        $(overlay).on('click', function () {
            $(this).removeClass("active");

            setTimeout(function () {
                $(self).parent().find('ul').css({transform: 'translateY(100%)'});
            }, 50);

            $(this).parent().find('ul').css({display: 'none'});
        });
    });

    $('.js-article-btn').on('click', function () {
        if ($(this).find('input').is(':checked') === false) {
            $(this).find('input').prop('checked', true);
            location.href = $(this).data('href')
        }
    });

    redirectToMenu();
});

function updateAppLinks() {
    if (document.getElementsByTagName("body")[0].className.match(/app-content/)) {
        const pageLinks = document.querySelectorAll("a");
        const appUrl = document.body.getAttribute('data-app-url');
        const mainUrl = new URL(appUrl);
        pageLinks.forEach(function (element) {
            const elLink = element.getAttribute('href');
            if (elLink && elLink.length !== 0 && elLink.indexOf(mainUrl.hostname) >= 0 || elLink && elLink.length !== 0 && elLink.indexOf('/') === 0) {
                const temporaryLinkUrl = new URL(elLink, appUrl);
                if (temporaryLinkUrl.search !== '' && temporaryLinkUrl.search.indexOf('?') >= 0) {
                    temporaryLinkUrl.search += '&source=app';
                } else {
                    temporaryLinkUrl.search = '?source=app';
                }
                element.setAttribute('href', temporaryLinkUrl.href);
            }
        })
    }
}

$(function () {
    loadMask();
    loadSelectize();
    // if ($(".invalid-feedback") !== undefined) {
    //     let err = $(".invalid-feedback");
    //     $("input").focus(function () {
    //         $(".code_error_input").removeClass('code_error_input');
    //         err.removeClass('invalid-feedback').html('');
    //     });
    // }
});

function loadMask() {
    Inputmask("+373 99 999 999").mask('.phone-mask');
    Inputmask({alias: "datetime", inputFormat: "dd/mm/yyyy"}).mask('.date-mask');
    const mod = $(".modal-confirm-phone");
    if (mod && mod.length) mod.addClass('show');
}

function loadSelectize() {
    const sz = $(".select-beast");
    if (sz && sz.length) {
        sz.selectize({
            create: true, highlight: true, dropdownParent: 'body', render: {
                'option_create': function (data, escape) {
                    return '<div class="create"><span class="add-icon"><svg width="8px" height="8px" viewBox="0 0 8 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' + '    <g stroke="none" stroke-width="1" fill-rule="evenodd">' + '        <path d="M3.34982453,0.65 L3.64882453,3.49882459 L6.5,3.49982465 L6.5,3.79982459 L3.64882453,3.79882453 L3.64982459,6.65 L3.34982465,6.65 L3.34882459,3.79882453 L0.5,3.79982447 L0.5,3.49982453 L3.34882459,3.49882459 L3.34982453,0.65 Z" id="icon_add" stroke="#303030" fill="#D8D8D8"></path>' + '    </g>' + '</svg></span>' + add_option + '&nbsp; <strong>' + escape(data.input) + '</strong>&hellip;</div>';
                }
            }, onChange: function (value) {
                $('.selectize-dropdown.select-beast .selected').removeClass('selected');
            }
        });
        $('.selectizer').removeClass('selectizer');
    }
}

$(function ($) {
    const subMenu = $(".md-menu-js");
    const newAddress = $(".add-new-address");
    const paId = document.getElementById('pickup_await');
    const eatingId = document.getElementById('eatingHere');
    const textInp = $('.js-text-input');
    const paymentType = $('input[name="payment_type"]');

    if (newAddress && newAddress.length) {

        const newAdrs = $('#new-address')
        const createAdrs = $('#create-address')

        $(newAddress).on('click', function () {
            newAdrs.css('display', 'block');
            createAdrs.css('display', 'none');
        });

        $('.create-address-cancel').on('click', function () {
            newAdrs.css('display', 'none');
            createAdrs.css('display', 'block');
        });

        $(document).on('submit', '.address-form', function () {
            if ($(this).hasClass('sended')) {
                return false;
            }
            $(this).addClass('sended');
        });

        let deletedHtml = null;
        let ADDRESS_ID = 0;

        $(document).on('click', '.address-delete', function () {
            if (ADDRESS_ID) {
                $('#address-' + ADDRESS_ID).html(deletedHtml);
            }

            ADDRESS_ID = $(this).data().id;
            let parent = $(this).closest('.js-parent');
            deletedHtml = parent.html();
            let questionHtml = $('#remove-address-question').html();
            parent.html(questionHtml);
            parent.find('.id').val($(this).data().id);

            $('html, body').animate({
                scrollTop: (parent.offset().top - 100)
            }, 300);
        });

        $(document).on('click', '.renunta', function () {
            let parent = $(this).closest('.js-parent');
            parent.html(deletedHtml);
            ADDRESS_ID = 0;
        });

        $(document).on('click', '.radio-input span', function () {
            console.log('click!');
            window.location.href = '/address-default/' + $(this).data().id;
        });

        $(document).on('click', 'button[type=reset]', function () {
            console.log('reset');
            let parent = $(this).closest('.js-parent');
            parent.find('.selectize-input div.item').val('').html('');
        });
    }

    if (paId) {
        $('.js-switch-pickup_await').on('click', function () {
            paId.value = $(this).data('val');

            if (!$(this).hasClass('activeButton')) {
                $('.js-switch-pickup_await').removeClass('activeButton').addClass('innactiveButton')
                $(this).addClass('activeButton')
            }
        });
    }

    if (eatingId) {
        $('.js-switch-eating-here').on('click', function () {
            eatingId.value = $(this).data('val');

            if (!$(this).hasClass('activeButton')) {
                $('.js-switch-eating-here').removeClass('activeButton').addClass('innactiveButton')
                $(this).addClass('activeButton')
            }
        });
    }

    if (textInp) {
        textInp.on('click', function () {
            $(this).find('input, select, textarea').focus();
        });
    }

    if (textInp) {
        paymentType.on('change', function () {
            let val = $(this).val();

            if (parseInt(val) == 3) {
                $('.holder-js').show();
                $('.holder-header').show();
                $('.holder-js input[type="text"]').attr('required', true);
            } else {
                $('.holder-header').hide();
                $('.holder-js').hide();
                $('.holder-js input[type="text"]').attr('required', false);
            }
        });
    }

    if (subMenu) {
        subMenu.on('click', function () {
            const menu = $(this).parent().find('.drop-items');
            if ($(this).hasClass('menu-link-active')) {
                $(this).removeClass('menu-link-active');
                menu.removeClass('drop-items-active');
            } else {
                $(this).addClass('menu-link-active');
                menu.addClass('drop-items-active');
            }
        });
    }
});

$(function () {
    $(document).on('click', '.js-cart-product-modifiers', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const link = e.target.getAttribute('data-get-info-link');
        const cartProductId = e.target.getAttribute('data-cart-item-uid');
        const modalContainer = $('.js-order-detail-info-modal');
        const modalContainerBody = modalContainer.find('.container-modal')

        $.ajax({
            url: link, type: "POST", data: {
                cartProductId: cartProductId
            }, dataType: 'json',
        }).done(function (response) {
            modalContainerBody.hide().html(response.form).fadeIn()

            const currentModal = $('.modal.show');
            if (currentModal) {
                modalContainer.modal('show');
            } else {
                if (response.form) {
                    currentModal.on('hidden.bs.modal', function () {
                        modalContainer.modal('show');
                        currentModal.unbind();
                    });
                }
                currentModal.modal('hide');
            }
        }).fail(function (jqXHR, textStatus) {
            $('.modal.show').modal('hide');

            alert("Request failed: " + textStatus);
        });
    })

    $(document).ready(function () {
        $('[data-toggle="tooltip"]').tooltip();
    });
})

function redirectToMenu() {
    let menu_redirect = sessionStorage.getItem('menu_redirect');

    if (menu_redirect && $('.frontpage').length) {
        sessionStorage.removeItem('menu_redirect');
        menu_redirect = menu_redirect.split('/');

        if (typeof menu_redirect[1] !== 'undefined' && menu_redirect[1] !== '') {
            const category = menu_redirect[1];
            $('[data-url="' + category + '"]').click();
        }
    }
}





// WEBPACK FOOTER //
// ./resources/assets/js/app.js